var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { BooleanInput, SelectInput, TextInput, useRecordContext, SimpleForm, useGetOne, Toolbar, SaveButton, useNotify, useRefresh, useUpdate, RecordContext, NumberInput, useGetList, FormDataConsumer, required, } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Tabs, Tab, Grid, Box, Typography, } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { CustomTabPanel } from "../../components/CustomTabPanel";
import { ElectionStyles } from "../../components/styles/ElectionStyles";
import { ContestsOrder, ECastVoteGoldLevelPolicy, EStartScreenTitlePolicy, EGracePeriodPolicy, ESecurityConfirmationPolicy, EVotingPortalAuditButtonCfg, EInitializeReportPolicy, EAllowTally, EConsolidatedReportPolicy, getDefaultConsolidatedReportPolicy, EDeclineToVotePolicy, getDefaultDeclineToVotePolicy, EBlankBallotsPolicy, getDefaultBlankBallotsPolicy, EElectionEventContestEncryptionPolicy, getDefaultVotingScreenBackPolicy, getVotingScreenBackPolicyValues, } from "@sequentech/ui-core";
import { DropFile } from "@sequentech/ui-essentials";
import FileJsonInput from "../../components/FileJsonInput";
import { GET_UPLOAD_URL } from "@/queries/GetUploadUrl";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { ITemplateMethod } from "@/types/templates";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { styled } from "@mui/material/styles";
import CustomOrderInput from "@/components/custom-order/CustomOrderInput";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { ManagedSelectInput } from "@/components/managed-inputs/ManagedSelectInput";
import { ManagedNumberInput } from "@/components/managed-inputs/ManagedNumberInput";
import { JsonEditor } from "json-edit-react";
import { useGetDocumentUrl } from "@/hooks/useGetDocumentUrl";
import { SettingsLanguageSelector } from "@/components/SettingsLanguageSelector";
import { IVR_ENTITY_I18N_ANNOTATION, parseIvrEntityAnnotations } from "@/utils/ivr";
var LangsWrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin-top: 46px;\n"], ["\n    margin-top: 46px;\n"])));
var ContestRows = styled("div")(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    cursor: pointer;\n    margin-bottom: 0.1rem;\n    padding: 1rem;\n"], ["\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    cursor: pointer;\n    margin-bottom: 0.1rem;\n    padding: 1rem;\n"])));
export var ElectionDataForm = function () {
    var _a, _b, _c, _d, _e, _f;
    var record = useRecordContext();
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var getImageUrl = useGetDocumentUrl();
    var getUploadUrl = useMutation(GET_UPLOAD_URL)[0];
    var notify = useNotify();
    var refresh = useRefresh();
    var authContext = useContext(AuthContext);
    var canEditPermissionLabel = authContext.isAuthorized(true, tenantId, IPermissions.PERMISSION_LABEL_WRITE);
    var canEdit = authContext.isAuthorized(true, authContext.tenantId, IPermissions.ELECTION_WRITE);
    var _g = useState(0), value = _g[0], setValue = _g[1];
    var _h = useState("election-data-general"), expanded = _h[0], setExpanded = _h[1];
    var _j = useState(["en"]), languageSettings = _j[0], setLanguageSettings = _j[1];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _k = useState(), customFilters = _k[0], setCustomFilters = _k[1];
    var _l = useState(false), activateSave = _l[0], setActivateSave = _l[1];
    var data = useGetOne("sequent_backend_election_event", {
        id: record === null || record === void 0 ? void 0 : record.election_event_id,
    }).data;
    var tenantData = useGetOne("sequent_backend_tenant", {
        id: (record === null || record === void 0 ? void 0 : record.tenant_id) || tenantId,
    }).data;
    var contests = useGetList("sequent_backend_contest", {
        filter: {
            election_id: record === null || record === void 0 ? void 0 : record.id,
            tenant_id: record === null || record === void 0 ? void 0 : record.tenant_id,
            election_event_id: record === null || record === void 0 ? void 0 : record.election_event_id,
        },
        pagination: { page: 1, perPage: 9999 },
    }).data;
    var _m = useGetOne("sequent_backend_document", {
        id: (record === null || record === void 0 ? void 0 : record.image_document_id) || (record === null || record === void 0 ? void 0 : record.tenant_id),
        meta: { tenant_id: record === null || record === void 0 ? void 0 : record.tenant_id },
    }, {
        enabled: !!(record === null || record === void 0 ? void 0 : record.image_document_id) || !!(record === null || record === void 0 ? void 0 : record.tenant_id),
        onError: function (error) {
            console.log("error fetching image doc: ".concat(error.message));
        },
        onSuccess: function () {
            console.log("success fetching image doc");
        },
    }), imageData = _m.data, refetchImage = _m.refetch;
    var updateImage = useUpdate()[0];
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!data || !record) {
            return;
        }
        var eventAvailableLangs = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.presentation) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.enabled_language_codes) !== null && _c !== void 0 ? _c : ["en"];
        var electionAvailableLangs = (_f = (_e = (_d = record === null || record === void 0 ? void 0 : record.presentation) === null || _d === void 0 ? void 0 : _d.language_conf) === null || _e === void 0 ? void 0 : _e.enabled_language_codes) !== null && _f !== void 0 ? _f : [];
        var newElectionLangs = electionAvailableLangs.filter(function (electionLang) { return !eventAvailableLangs.includes(electionLang); });
        var completeList = eventAvailableLangs.concat(newElectionLangs);
        setLanguageSettings(completeList);
    }, [
        (_b = (_a = data === null || data === void 0 ? void 0 : data.presentation) === null || _a === void 0 ? void 0 : _a.language_conf) === null || _b === void 0 ? void 0 : _b.enabled_language_codes,
        (_d = (_c = record === null || record === void 0 ? void 0 : record.presentation) === null || _c === void 0 ? void 0 : _c.language_conf) === null || _d === void 0 ? void 0 : _d.enabled_language_codes,
    ]);
    var parseValues = useCallback(function (incoming, languageSettings) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
        var _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        if (!data) {
            return incoming;
        }
        var temp = __assign({}, incoming);
        var incomingLangConf = (_a = incoming === null || incoming === void 0 ? void 0 : incoming.presentation) === null || _a === void 0 ? void 0 : _a.language_conf;
        if ((incomingLangConf === null || incomingLangConf === void 0 ? void 0 : incomingLangConf.enabled_language_codes) &&
            (incomingLangConf === null || incomingLangConf === void 0 ? void 0 : incomingLangConf.enabled_language_codes.length) > 0) {
            var _loop_1 = function (setting) {
                var enabled_item = {};
                var isInEnabled = (_c = (_b = incomingLangConf === null || incomingLangConf === void 0 ? void 0 : incomingLangConf.enabled_language_codes) === null || _b === void 0 ? void 0 : _b.find(function (item) { return setting === item; })) !== null && _c !== void 0 ? _c : false;
                enabled_item[setting] = !!isInEnabled;
                temp.enabled_languages = __assign(__assign({}, temp.enabled_languages), enabled_item);
            };
            // if presentation has lang then set from event
            for (var _i = 0, languageSettings_1 = languageSettings; _i < languageSettings_1.length; _i++) {
                var setting = languageSettings_1[_i];
                _loop_1(setting);
            }
        }
        else {
            // if presentation has no lang then use always the default settings
            temp.enabled_languages = __assign({}, temp.enabled_languages);
            for (var _11 = 0, languageSettings_2 = languageSettings; _11 < languageSettings_2.length; _11++) {
                var item = languageSettings_2[_11];
                temp.enabled_languages[item] = false;
            }
        }
        if (!(incoming === null || incoming === void 0 ? void 0 : incoming.presentation)) {
            temp.presentation = {};
        }
        if (temp.presentation && !temp.presentation.language_conf) {
            temp.presentation.language_conf = {};
        }
        if (temp.presentation && !temp.presentation.dates) {
            temp.presentation.dates = {};
        }
        if (temp.presentation) {
            temp.scheduledOpening = (_e = (_d = temp.presentation) === null || _d === void 0 ? void 0 : _d.dates) === null || _e === void 0 ? void 0 : _e.scheduled_opening;
            temp.scheduledClosing = (_g = (_f = temp.presentation) === null || _f === void 0 ? void 0 : _f.dates) === null || _g === void 0 ? void 0 : _g.scheduled_closing;
        }
        if (!temp.presentation) {
            temp.presentation = {};
        }
        temp.presentation.contests_order =
            temp.presentation.contests_order || ContestsOrder.ALPHABETICAL;
        (_h = (_0 = temp.presentation).audit_button_cfg) !== null && _h !== void 0 ? _h : (_0.audit_button_cfg = EVotingPortalAuditButtonCfg.SHOW);
        (_j = (_1 = temp.presentation).cast_vote_gold_level) !== null && _j !== void 0 ? _j : (_1.cast_vote_gold_level = ECastVoteGoldLevelPolicy.NO_GOLD_LEVEL);
        (_k = (_2 = temp.presentation).start_screen_title_policy) !== null && _k !== void 0 ? _k : (_2.start_screen_title_policy = EStartScreenTitlePolicy.ELECTION);
        (_l = (_3 = temp.presentation).security_confirmation_policy) !== null && _l !== void 0 ? _l : (_3.security_confirmation_policy = ESecurityConfirmationPolicy.NONE);
        (_m = (_4 = temp.presentation).initialization_report_policy) !== null && _m !== void 0 ? _m : (_4.initialization_report_policy = EInitializeReportPolicy.NOT_REQUIRED);
        (_o = (_5 = temp.presentation).grace_period_policy) !== null && _o !== void 0 ? _o : (_5.grace_period_policy = EGracePeriodPolicy.NO_GRACE_PERIOD);
        (_p = (_6 = temp.presentation).grace_period_secs) !== null && _p !== void 0 ? _p : (_6.grace_period_secs = 0);
        (_q = (_7 = temp.presentation).consolidated_report_policy) !== null && _q !== void 0 ? _q : (_7.consolidated_report_policy = getDefaultConsolidatedReportPolicy());
        (_r = (_8 = temp.presentation).decline_to_vote_policy) !== null && _r !== void 0 ? _r : (_8.decline_to_vote_policy = getDefaultDeclineToVotePolicy());
        (_s = (_9 = temp.presentation).blank_ballots_policy) !== null && _s !== void 0 ? _s : (_9.blank_ballots_policy = getDefaultBlankBallotsPolicy());
        (_t = (_10 = temp.presentation).voting_screen_back_policy) !== null && _t !== void 0 ? _t : (_10.voting_screen_back_policy = getDefaultVotingScreenBackPolicy());
        var votingSettings = (data === null || data === void 0 ? void 0 : data.voting_channels) || (tenantData === null || tenantData === void 0 ? void 0 : tenantData.voting_channels);
        // set english first lang always
        if (temp.enabled_languages) {
            var en = { en: temp.enabled_languages["en"] };
            delete temp.enabled_languages.en;
            var rest = temp.enabled_languages;
            temp.enabled_languages = __assign(__assign({}, en), rest);
        }
        // voting channels
        var all_channels = __assign({}, incoming === null || incoming === void 0 ? void 0 : incoming.voting_channels);
        // delete incoming.voting_channels
        temp.voting_channels = {};
        for (var setting in votingSettings) {
            var enabled_item = {};
            enabled_item[setting] =
                setting in all_channels ? all_channels[setting] : votingSettings[setting];
            temp.voting_channels = __assign(__assign({}, temp.voting_channels), enabled_item);
        }
        // name, alias and description fields
        if (!temp.presentation) {
            temp.presentation = {};
        }
        if (!((_u = temp.presentation) === null || _u === void 0 ? void 0 : _u.i18n)) {
            temp.presentation.i18n = {};
        }
        if (!((_w = (_v = temp.presentation) === null || _v === void 0 ? void 0 : _v.i18n) === null || _w === void 0 ? void 0 : _w.en)) {
            temp.presentation.i18n.en = {};
        }
        temp.presentation.i18n.en.description = temp.description;
        temp.annotations = parseIvrEntityAnnotations(temp.annotations);
        // receipts
        var template = {};
        var allowed = {};
        if (temp.receipts) {
            for (var value_1 in Object.values(ITemplateMethod)) {
                var key = Object.keys(ITemplateMethod)[value_1];
                allowed[key] = (_x = temp.receipts[key]) === null || _x === void 0 ? void 0 : _x.allowed;
                template[key] = (_y = temp.receipts[key]) === null || _y === void 0 ? void 0 : _y.template;
            }
            temp.allowed = allowed;
            temp.template = template;
        }
        // defaults
        temp.presentation.initialization_report_policy =
            temp.presentation.initialization_report_policy ||
                EInitializeReportPolicy.NOT_REQUIRED;
        temp.num_allowed_revotes =
            temp.num_allowed_revotes != null ? temp.num_allowed_revotes : 1;
        temp.presentation.grace_period_policy =
            temp.presentation.grace_period_policy || EGracePeriodPolicy.NO_GRACE_PERIOD;
        temp.presentation.grace_period_secs = temp.presentation.grace_period_secs || 0;
        if (!customFilters && ((_z = temp === null || temp === void 0 ? void 0 : temp.presentation) === null || _z === void 0 ? void 0 : _z.custom_filters)) {
            setCustomFilters(temp.presentation.custom_filters);
        }
        return temp;
    }, [data, tenantData === null || tenantData === void 0 ? void 0 : tenantData.voting_channels]);
    var handleChange = function (_event, newValue) {
        setValue(newValue);
    };
    var renderVotingChannels = function (parsedValue) {
        var channelNodes = [];
        for (var channel in parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.voting_channels) {
            channelNodes.push(_jsx(BooleanInput, { source: "voting_channels[".concat(channel, "]"), label: String(t("common.channel.".concat(channel))) }, channel));
        }
        return channelNodes;
    };
    var renderTabs = function (parsedValue) {
        var _a;
        var tabNodes = [];
        for (var lang in parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.enabled_languages) {
            if ((_a = parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.enabled_languages) === null || _a === void 0 ? void 0 : _a[lang]) {
                tabNodes.push(_jsx(Tab, { label: String(t("common.language.".concat(lang))), id: lang }, lang));
            }
        }
        // reset actived tab to first tab if only one
        if (tabNodes.length === 1) {
            setValue(0);
        }
        return tabNodes;
    };
    // TODO: renderReceipts
    var renderTabContent = function (parsedValue) {
        var _a, _b;
        var tabNodes = [];
        var index = 0;
        var hasTos = ESecurityConfirmationPolicy.MANDATORY ===
            ((_a = parsedValue.presentation) === null || _a === void 0 ? void 0 : _a.security_confirmation_policy);
        for (var lang in parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.enabled_languages) {
            if ((_b = parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.enabled_languages) === null || _b === void 0 ? void 0 : _b[lang]) {
                tabNodes.push(_jsx(CustomTabPanel, { value: value, index: index, children: _jsxs("div", { style: { marginTop: "16px" }, children: [_jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].name"), label: String(t("electionEventScreen.field.name")) }), _jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].alias"), label: String(t("electionEventScreen.field.alias")) }), _jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].description"), label: String(t("electionEventScreen.field.description")) }), _jsx(TextInput, { source: "annotations.".concat(IVR_ENTITY_I18N_ANNOTATION, ".").concat(lang, ".prompt"), label: String(t("electionScreen.field.ivrPrompt")) }), hasTos ? (_jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].security_confirmation_html"), label: String(t("electionScreen.field.securityConfirmationHtml")) })) : null] }) }, lang));
                index++;
            }
        }
        return tabNodes;
    };
    var handleFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var theFile, data_1, e_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    theFile = files === null || files === void 0 ? void 0 : files[0];
                    if (!theFile) return [3 /*break*/, 7];
                    return [4 /*yield*/, getUploadUrl({
                            variables: {
                                name: theFile.name,
                                media_type: theFile.type,
                                size: theFile.size,
                            },
                        })];
                case 1:
                    data_1 = (_b.sent()).data;
                    if (!((_a = data_1 === null || data_1 === void 0 ? void 0 : data_1.get_upload_url) === null || _a === void 0 ? void 0 : _a.document_id)) return [3 /*break*/, 6];
                    _b.label = 2;
                case 2:
                    _b.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, fetch(data_1.get_upload_url.url, {
                            method: "PUT",
                            headers: {
                                "Content-Type": "image/*",
                            },
                            body: theFile,
                        })];
                case 3:
                    _b.sent();
                    notify(t("electionScreen.error.fileLoaded"), { type: "success" });
                    updateImage("sequent_backend_election", {
                        id: record === null || record === void 0 ? void 0 : record.id,
                        data: {
                            image_document_id: data_1.get_upload_url.document_id,
                        },
                    });
                    refetchImage();
                    refresh();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _b.sent();
                    notify(t("electionScreen.error.fileError"), { type: "error" });
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    notify(t("electionScreen.error.fileError"), { type: "error" });
                    _b.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var gracePeriodPolicyChoices = function () {
        return Object.values(EGracePeriodPolicy).map(function (value) { return ({
            id: value,
            name: t("electionScreen.gracePeriodPolicy.".concat(value.toLowerCase())),
        }); });
    };
    var allowTallyChoices = function () {
        return Object.values(EAllowTally).map(function (value) { return ({
            id: value,
            name: t("electionScreen.allowTallyPolicy.".concat(value.toLowerCase())),
        }); });
    };
    var securityConfirmationPolicyChoices = function () {
        return Object.values(ESecurityConfirmationPolicy).map(function (value) { return ({
            id: value,
            name: t("electionScreen.securityConfirmationPolicy.".concat(value.toLowerCase())),
        }); });
    };
    var sortedContests = (contests !== null && contests !== void 0 ? contests : []).sort(function (a, b) {
        var _a, _b;
        var presentationA = a.presentation;
        var presentationB = b.presentation;
        var sortOrderA = (_a = presentationA === null || presentationA === void 0 ? void 0 : presentationA.sort_order) !== null && _a !== void 0 ? _a : -1;
        var sortOrderB = (_b = presentationB === null || presentationB === void 0 ? void 0 : presentationB.sort_order) !== null && _b !== void 0 ? _b : -1;
        return sortOrderA - sortOrderB;
    });
    var orderAnswerChoices = function () {
        return Object.values(ContestsOrder).map(function (value) { return ({
            id: value,
            name: t("contestScreen.options.".concat(value.toLowerCase())),
        }); });
    };
    var startScreenTitleChoices = function () {
        return Object.values(EStartScreenTitlePolicy).map(function (value) { return ({
            id: value,
            name: t("electionScreen.startScreenTitlePolicy.options.".concat(value.toLowerCase())),
        }); });
    };
    var goldLevelChoices = function () {
        return Object.values(ECastVoteGoldLevelPolicy).map(function (value) { return ({
            id: value,
            name: t("electionScreen.castVoteGoldLevelPolicy.options.".concat(value.toLowerCase())),
        }); });
    };
    var auditButtonConfigChoices = function () {
        return Object.values(EVotingPortalAuditButtonCfg).map(function (value) { return ({
            id: value,
            name: t("contestScreen.auditButtonConfig.".concat(value.toLowerCase())),
        }); });
    };
    var initializationReportChoices = function () {
        return Object.values(EInitializeReportPolicy).map(function (value) { return ({
            id: value,
            name: t("electionScreen.initializeReportPolicy.".concat(value.toLowerCase())),
        }); });
    };
    var consolidatedReportPolicyChoices = function () {
        return Object.values(EConsolidatedReportPolicy).map(function (value) { return ({
            id: value,
            name: t("electionScreen.consolidatedReportPolicy.options.".concat(value.toLowerCase())),
        }); });
    };
    var declineToVotePolicyChoices = function () {
        return Object.values(EDeclineToVotePolicy).map(function (value) { return ({
            id: value,
            name: t("electionScreen.declineToVotePolicy.options.".concat(value.toLowerCase())),
        }); });
    };
    var blankBallotsPolicyChoices = function () {
        return Object.values(EBlankBallotsPolicy).map(function (value) { return ({
            id: value,
            name: t("electionScreen.blankBallotsPolicy.options.".concat(value.toLowerCase())),
        }); });
    };
    var votingScreenBackPolicyChoices = function () {
        return getVotingScreenBackPolicyValues().map(function (value) { return ({
            id: value,
            name: t("electionScreen.votingScreenBackPolicy.options.".concat(value)),
        }); });
    };
    var updateCustomFilters = function (values, _a) {
        var newData = _a.newData;
        values.presentation.custom_filters = newData;
        setCustomFilters(newData);
        setActivateSave(true);
    };
    var isShowDeclineToVotePolicy = ((_e = data === null || data === void 0 ? void 0 : data.presentation) === null || _e === void 0 ? void 0 : _e.contest_encryption_policy) === EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
    var isShowBlankBallotsPolicy = ((_f = data === null || data === void 0 ? void 0 : data.presentation) === null || _f === void 0 ? void 0 : _f.contest_encryption_policy) === EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
    return record && data ? (_jsx(RecordContext.Consumer, { children: function (incoming) {
            var parsedValue = parseValues(incoming, languageSettings);
            var imageUrl = getImageUrl(parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.tenant_id, parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id, imageData === null || imageData === void 0 ? void 0 : imageData.name);
            var onSave = function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/];
            }); }); };
            return (_jsxs(SimpleForm, { defaultValues: { contestsOrder: sortedContests }, record: parsedValue, toolbar: _jsx(Toolbar, { children: canEdit && (_jsx(SaveButton, { onClick: function () {
                            onSave();
                        }, type: "button" })) }), children: [_jsxs(Accordion, { sx: { width: "100%" }, expanded: expanded === "election-data-general", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "election-data-general" ? "" : "election-data-general";
                            });
                        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "election-data-general" }), children: _jsx(ElectionStyles.Wrapper, { children: _jsx(ElectionStyles.Title, { children: t("electionScreen.edit.general") }) }) }), _jsxs(AccordionDetails, { children: [_jsx(TextInput, { source: "external_id", label: String(t("electionScreen.field.externalId")), readOnly: !!record.external_id }), _jsx(Tabs, { value: value, onChange: handleChange, children: renderTabs(parsedValue) }), renderTabContent(parsedValue)] })] }), _jsxs(Accordion, { sx: { width: "100%" }, expanded: expanded === "election-data-language", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "election-data-language"
                                    ? ""
                                    : "election-data-language";
                            });
                        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "election-data-language" }), children: _jsx(ElectionStyles.Wrapper, { children: _jsx(ElectionStyles.Title, { children: t("electionScreen.edit.language") }) }) }), _jsx(AccordionDetails, { children: _jsx(ElectionStyles.AccordionContainer, { children: _jsx(ElectionStyles.AccordionWrapper, { children: _jsx(SettingsLanguageSelector, { languageSettings: languageSettings, canEdit: canEdit }) }) }) })] }), _jsxs(Accordion, { sx: { width: "100%" }, expanded: expanded === "election-data-allowed", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "election-data-allowed" ? "" : "election-data-allowed";
                            });
                        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "election-data-allowed" }), children: _jsx(ElectionStyles.Wrapper, { children: _jsx(ElectionStyles.Title, { children: t("electionScreen.edit.allowed") }) }) }), _jsx(AccordionDetails, { children: _jsx(Grid, { container: true, spacing: 4, children: _jsx(Grid, { size: { xs: 12, md: 6 }, children: renderVotingChannels(parsedValue) }) }) })] }), _jsxs(Accordion, { sx: { width: "100%" }, expanded: expanded === "contest-data-design", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "contest-data-design" ? "" : "contest-data-design";
                            });
                        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "contest-data-design" }), children: _jsx(ElectionStyles.Wrapper, { children: _jsx(ElectionStyles.Title, { children: t("contestScreen.edit.design") }) }) }), _jsxs(AccordionDetails, { children: [_jsx(SelectInput, { source: "presentation.audit_button_cfg", choices: auditButtonConfigChoices(), label: String(t("contestScreen.auditButtonConfig.label")), defaultValue: EVotingPortalAuditButtonCfg.SHOW, validate: required() }), _jsx(SelectInput, { source: "presentation.contests_order", choices: orderAnswerChoices(), validate: required(), defaultValue: ContestsOrder.ALPHABETICAL }), _jsx(FormDataConsumer, { children: function (_a) {
                                            var _b;
                                            var formData = _a.formData, rest = __rest(_a, ["formData"]);
                                            return ((_b = formData === null || formData === void 0 ? void 0 : formData.presentation) === null || _b === void 0 ? void 0 : _b.contests_order) === ContestsOrder.CUSTOM ? (_jsxs(ContestRows, { children: [_jsx(Typography, { variant: "body1", component: "span", sx: {
                                                            padding: "0.5rem 1rem",
                                                            fontWeight: "bold",
                                                            margin: 0,
                                                            display: { xs: "none", sm: "block" },
                                                        }, children: t("electionScreen.edit.reorder") }), _jsx(CustomOrderInput, { source: "contestsOrder" }), _jsx(Box, { sx: { width: "100%", height: "180px" } })] })) : null;
                                        } })] })] }), _jsxs(Accordion, { sx: { width: "100%" }, expanded: expanded === "election-data-image", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "election-data-image" ? "" : "election-data-image";
                            });
                        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "election-data-image" }), children: _jsx(ElectionStyles.Wrapper, { children: _jsx(ElectionStyles.Title, { children: t("electionScreen.edit.image") }) }) }), _jsx(AccordionDetails, { children: _jsxs(Grid, { container: true, spacing: 1, children: [_jsx(Grid, { size: 2, children: (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id) &&
                                                (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id) !== "" ? (_jsx("img", { width: 200, height: 200, src: "".concat(globalSettings.PUBLIC_BUCKET_URL).concat(imageUrl), alt: imageUrl })) : null }), _jsx(Grid, { size: 10, children: _jsx(DropFile, { handleFiles: function (files) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                                    return [2 /*return*/, handleFiles(files)];
                                                }); }); } }) })] }) })] }), _jsxs(Accordion, { sx: { width: "100%" }, expanded: expanded === "election-data-advanced", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "election-data-advanced"
                                    ? ""
                                    : "election-data-advanced";
                            });
                        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "election-data-advanced" }), children: _jsx(ElectionStyles.Wrapper, { children: _jsx(ElectionStyles.Title, { children: t("electionScreen.edit.advanced") }) }) }), _jsxs(AccordionDetails, { children: [_jsx(BooleanInput, { source: "presentation.cast_vote_confirm", label: String(t("electionScreen.edit.castVoteConfirm")) }), _jsx(NumberInput, { source: "num_allowed_revotes", label: String(t("electionScreen.edit.numAllowedVotes")), min: 0 }), _jsx(SelectInput, { label: String(t("electionScreen.castVoteGoldLevelPolicy.label")), source: "presentation.cast_vote_gold_level", choices: goldLevelChoices(), defaultValue: ECastVoteGoldLevelPolicy.NO_GOLD_LEVEL, validate: required() }), _jsx(SelectInput, { label: String(t("electionScreen.startScreenTitlePolicy.label")), source: "presentation.start_screen_title_policy", choices: startScreenTitleChoices(), defaultValue: EStartScreenTitlePolicy.ELECTION, validate: required() }), canEditPermissionLabel && (_jsx(TextInput, { label: String(t("electionScreen.edit.permissionLabel")), source: "permission_label" })), _jsx(FileJsonInput, { parsedValue: parsedValue, fileSource: "configuration", jsonSource: "presentation" }), _jsx(SelectInput, { source: "presentation.initialization_report_policy", choices: initializationReportChoices(), label: String(t("electionScreen.initializeReportPolicy.label")), validate: required(), defaultValue: EInitializeReportPolicy.NOT_REQUIRED }), _jsxs(Box, { children: [_jsx(Typography, { variant: "body1", component: "span", sx: {
                                                    padding: "1rem 0rem",
                                                    fontWeight: "bold",
                                                    margin: 0,
                                                    display: { xs: "none", sm: "block" },
                                                }, children: t("electionScreen.edit.custom_filters") }), _jsx(JsonEditor, { data: customFilters !== null && customFilters !== void 0 ? customFilters : [], onUpdate: function (data) {
                                                    return updateCustomFilters(parsedValue, data);
                                                } })] }), _jsx(ManagedSelectInput, { source: "presentation.grace_period_policy", choices: gracePeriodPolicyChoices(), label: String(t("electionScreen.gracePeriodPolicy.label")), defaultValue: EGracePeriodPolicy.NO_GRACE_PERIOD }), _jsx(ManagedNumberInput, { source: "presentation.grace_period_secs", label: String(t("electionScreen.gracePeriodPolicy.gracePeriodSecs")), defaultValue: 0, sourceToWatch: "presentation.grace_period_policy", isDisabled: function (selectedPolicy) {
                                            return selectedPolicy === EGracePeriodPolicy.NO_GRACE_PERIOD;
                                        } }), _jsx(ManagedSelectInput, { source: "status.allow_tally", choices: allowTallyChoices(), label: String(t("electionScreen.edit.allowTallyPolicy")), defaultValue: EAllowTally.ALLOWED }), _jsx(ManagedSelectInput, { source: "presentation.security_confirmation_policy", choices: securityConfirmationPolicyChoices(), label: String(t("electionScreen.securityConfirmationPolicy.label")), defaultValue: ESecurityConfirmationPolicy.NONE }), _jsx(SelectInput, { source: "presentation.consolidated_report_policy", choices: consolidatedReportPolicyChoices(), label: String(t("electionScreen.consolidatedReportPolicy.label")), validate: required(), defaultValue: getDefaultConsolidatedReportPolicy() }), isShowDeclineToVotePolicy && (_jsx(SelectInput, { source: "presentation.decline_to_vote_policy", choices: declineToVotePolicyChoices(), label: String(t("electionScreen.declineToVotePolicy.label")), validate: required(), defaultValue: getDefaultDeclineToVotePolicy() })), isShowBlankBallotsPolicy && (_jsx(SelectInput, { source: "presentation.blank_ballots_policy", choices: blankBallotsPolicyChoices(), label: String(t("electionScreen.blankBallotsPolicy.label")), validate: required(), defaultValue: getDefaultBlankBallotsPolicy() })), _jsx(SelectInput, { source: "presentation.voting_screen_back_policy", choices: votingScreenBackPolicyChoices(), label: String(t("electionScreen.votingScreenBackPolicy.label")), validate: required(), defaultValue: getDefaultVotingScreenBackPolicy() })] })] })] }));
        } })) : null;
};
var templateObject_1, templateObject_2;
